import posthog from "posthog-js"
import {
	type FCPMetric,
	type INPMetric,
	type LCPMetric,
	onFCP,
	onINP,
	onLCP,
} from "web-vitals"

type Metric = FCPMetric | INPMetric | LCPMetric

const FLUSH_DELAY_MS = 5000
const MAX_VALUE_MS = 15 * 60 * 1000

function toProperties(url: string, metrics: Metric[]): Record<string, unknown> {
	const properties: Record<string, unknown> = { $current_url: url }
	for (const { entries: _entries, ...metric } of metrics) {
		properties[`$web_vitals_${metric.name}_event`] = {
			...metric,
			$current_url: url,
		}
		properties[`$web_vitals_${metric.name}_value`] = metric.value
	}
	return properties
}

class WebVitalsBuffer {
	private url: string | null = null
	private metrics: Metric[] = []
	private timer: ReturnType<typeof setTimeout> | undefined

	add = (metric: Metric) => {
		if (metric.value >= MAX_VALUE_MS) return

		const url = metric.navigationURL ?? window.location.href
		if (url !== this.url) {
			this.flush()
			this.url = url
			this.timer = setTimeout(this.flush, FLUSH_DELAY_MS)
		}
		this.metrics.push(metric)
	}

	flush = () => {
		clearTimeout(this.timer)
		this.timer = undefined
		if (this.url === null || this.metrics.length === 0) return

		posthog.capture("$web_vitals", toProperties(this.url, this.metrics))
		this.url = null
		this.metrics = []
	}
}

export function captureCapacitorWebVitals(): void {
	if (window.location.protocol !== "capacitor:") return

	const buffer = new WebVitalsBuffer()
	onFCP(buffer.add)
	onLCP(buffer.add)
	onINP(buffer.add)
}
